import { render, staticRenderFns } from "./DayInactivityIntervalsListPage.vue?vue&type=template&id=60291b58&"
import script from "./DayInactivityIntervalsListPage.vue?vue&type=script&lang=ts&"
export * from "./DayInactivityIntervalsListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports